import { GNewWindowedSelect } from 'components/basic-blocks/g-new-virtualized-select'
import { MCCAccountLinkDTO, GoogleAdsAccountBasicInfoDTO } from './types'
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters'
import { GTooltip } from 'components/basic-blocks'
import { AiOutlineQuestionCircle } from 'react-icons/ai'

interface MccClientSelectorProps {
	mccLink: MCCAccountLinkDTO
	selectedClient: GoogleAdsAccountBasicInfoDTO | null
	loading: boolean
	onChange: (client: GoogleAdsAccountBasicInfoDTO) => void
}

const GoogleAdsOptionLabel = ({
	opt
}: {
	opt: GoogleAdsAccountBasicInfoDTO
}) => {
	if (opt?.name) {
		return (
			<div className="flex items-center w-full gap-2">
				<span className="truncate">
					{opt.name} <span>({opt.account_number})</span>
				</span>
				{opt.manager && (
					<span className="flex-shrink-0 px-[6px] py-[2px] text-[11px] font-medium border bg-t-step-inactive border-brand text-[color:var(--brand-chip-ink,#554BFD)] rounded-full leading-[14px]">
						MCC
					</span>
				)}
			</div>
		)
	}
	return <>{opt?.account_number || ''}</>
}

export const MccClientSelector = ({
	mccLink,
	selectedClient,
	loading,
	onChange
}: MccClientSelectorProps) => {
	return (
		<div className="flex flex-col gap-4">
			<div className="flex items-center gap-2">
				<label className="text-[16px] leading-[22px] font-medium text-t-google-ad">
					Google Ads account
				</label>
				<GTooltip
					content="If you don’t see the Google Ads account you’re looking for, the email you authorized may not have access to it. Select another Google credential from the dropdown above to authorize a different email address."
					position="top"
					arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
					contentClassName="border-none mb-2 bg-t-smoke font-medium text-sm text-t-desc-gray"
				>
					<AiOutlineQuestionCircle className="text-t-gray-hold w-4 h-4" />
				</GTooltip>
			</div>
			<GNewWindowedSelect
				label="Client account"
				options={[...(mccLink.clients || [])]}
				value={selectedClient}
				isDisabled={loading}
				onChange={(newValue) =>
					onChange(newValue as GoogleAdsAccountBasicInfoDTO)
				}
				formatOptionLabel={(option) => {
					const opt = option as GoogleAdsAccountBasicInfoDTO
					return <GoogleAdsOptionLabel opt={opt} />
				}}
				getOptionLabelComponent={(option) => {
					const opt = option as GoogleAdsAccountBasicInfoDTO
					return <GoogleAdsOptionLabel opt={opt} />
				}}
				placeholder="Find account"
				isOptionSelected={(option) =>
					(option as GoogleAdsAccountBasicInfoDTO).account_number ===
					selectedClient?.account_number
				}
				filterOption={(option, query) => {
					if (!query) return true
					const opt = (
						option as FilterOptionOption<GoogleAdsAccountBasicInfoDTO>
					).data
					const accountNumber = opt?.account_number?.toLocaleLowerCase() || ''
					const name = opt?.name?.toLocaleLowerCase() || ''
					const lowerQuery = query.toLocaleLowerCase()
					return accountNumber.includes(lowerQuery) || name.includes(lowerQuery)
				}}
			/>
		</div>
	)
}
